import React from 'react'
import { usePartner } from '@@partner:helpers/hooks/auth'

import BannersGrid from '@components/marketing/banners/BannersGrid'

export default function BannersPage () {
  const { brandSlug } = usePartner()

  return (
    <BannersGrid brandSlug={brandSlug} />
  )
}
